// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {applyMiddleware, createStore} from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootReducers from './rootReducer';
import rootSaga from './../businessLogic/sagas/rootSagas';

// TODO: break down reducers types for each reducer instead of all together
export type AppState = ReturnType<typeof rootReducers>;

const sagaMiddleware = createSagaMiddleware();

function configureStore() {
    const middlewares = [sagaMiddleware];
    // TODO: add redux logger
    const middleWareEnhancer = applyMiddleware(...middlewares);

    if (process.env.NODE_ENV === 'development') {
        const { composeWithDevTools } = require('redux-devtools-extension');
        return createStore(
            rootReducers,
            // TODO: find out if we should remove redux dev tools in production or not.
            composeWithDevTools(middleWareEnhancer)
        );
    }
    
    return createStore(rootReducers, middleWareEnhancer);
}

export default configureStore();

sagaMiddleware.run(rootSaga);
